export default "__VITE_ASSET__DG4acroU__"